export default {
  DESKTOP_BANNER: 'D',
  MOBILE_BANNER: 'M',
  SQUARE: 'S',
  VERTICAL: 'V',
  LEADERBOARD: 'L',
  BILLBOARD: 'B',
  SKYSCRAPER: 'K'
}
